export const updateArtisanPrice = async (artisan_price_list_item_id, price_column, value) => {
    try {
        const response = await fetch(`/api/artisan_price_item/update`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:                       true,
                artisan_price_list_item_id: artisan_price_list_item_id,
                price_column:               price_column,
                value:                      value,
            })
        });

        const updateArtisanItemResponse = await response.json();
        notify(updateArtisanItemResponse.message, 'green');
        removeLoadingOverlay()


    } catch (error) {
        console.log(error)
        removeLoadingOverlay()
    }
}
